/*
 * @Author: wuxi
 * @Date: 2020-11-27 11:43:57
 * @LastEditors: wuxi
 * @LastEditTime: 2022-04-21 10:55:14
 * @FilePath: \csx-b2b-front-supplier\public\Title.js
 * @Description:
 *
 *
 */
module.exports = {
  home: '首页',
  login: '登录',
  userRegistered: '注册',
  notFound404: '404',
  reconciliationManagement: '对账管理',
  entryAndCore: '发票录入与票核',
  orderNotice: '订货通知单',
  orderNoticeDes: '订货通知单详情',
  StoreDetails: '门店明细',
  printDocument: '打印单据',
  editPwd: '修改密码',
  accountPhoneEdit: '主账号手机修改',
  defaultSelect: '设置默认供应商',
  accountManagement: '子账号管理',
  supplierAndWeiChat: '供应商与微信管理',
  orderAccept: '验收单',
  orderAcceptDes: '验收单详情',
  orderAcceptPrint: '验收单打印',
  returnNotice: '退货通知单',
  returnNoticeDes: '退货通知单详情',
  returnNoticePrint: '退货通知单打印',
  returnFrom: '退货单',
  returnFromDes: '退货单详情',
  returnFromPrint: '退货单打印',

  businessQueries: '电子签章业务查询',
  changeQueries: '手机变更查询',
  applyApproval: '电子签章签章申请审批',
  phoneChangeApproval: '电子签章手机号变更审批',
  businessApplications: '电子签章签章业务申请',
  editPhone: '电子签章手机号新增/变更',
  PurchaseOrderMonitoring: '采购单监控',

  signatureStatement: '对账单签章状态查询',
  unpaidAmount: '供应商款项信息查询',
  documentFreezing: '对账单据明细查询',
  vendorPayment: '付款单查询',
  reconciliationInformation: '对账信息查询',
  invoiceManagement: '票核情况查询',
  expenseQuery: '供应商费用单查询',
  salesDataQuery: '销售数据查询',
  //商品管理
  productStockPrice: '商品库存报价管理',
  productStockPriceImport: '商品库存报价管理导入',

  reserveDeliver: '预约送货',
  reserveDeliverDetail: '预约送货详情',
  FindPhoneNum: '找回手机号',
  validityMaintenance: '效期维护',
  //bbc履约管理
  Scope: '配送范围限制',
  holiday: '不发货时间段',
  expressSearch: '快递编码查询',
  bbcOrderManagement: '供应商订单管理',
  bbcGoodsManagement: '供应商商品管理',
  bbcOrderDetail: '订单详情',
  bbcGoodsView: '供应商商品详情',
  bbcGoodsChange: '供应商商品变更',
  bbcGoodsChangeDeliveryRange: '变更配送范围',
  priceList: '报价单',
  supplyType: '商品型检证件',
  SortingDataQuery: '委外实时分拣数量查询',
  supplierFreightRules: '运费参数配置',
  winningBidder: '中标候选商品池',
  bidManagement: '商品报价管理',
  outsourcingDetailsReport: '委外需求明细报表',
  FreightBillCheck: '运费账单核对',
  inquiryPrice: '询价管理',
  prePurchase: '预采通知单',
  prePurchaseDetail: '预采通知单详情',
  preProcurement: '预采需求看板',
  supplierCredential: '供应商证件',
  myProfile: '我的资料',
  ApplyBilling: '开票申请',
  InvoiceRecord: '开票申请记录',
  BillingInquiry: '开票查询',
  ProductCreate: '新品申请',
  reconciliationCommission: '代售业务对账',
  maximumDailySupplyCapacity: '日最大供货能力配置',
  qutsourcingRequirementDashboard: '委外需求看板',
  InvoiceSend: '发票寄送',
  defaultDisposal: '违约处置单',
  bbcGoodsManagementNew: 'BBC联营商品管理',
  NewbbcGoodsView: '供应商商品详情新',
  bbcGoodsChangeNew: '商品编辑新',
  deliveryTime: '发货时效',
  SupplierFeeComplaint: '供应商费用申诉',
  batchInspectionCertificate: '商品批检证件',
  manufacturerCertificate: '生产厂家证件',
  supplierSafetyStockConfig: '联营供应商安全库存配置',
  intendedSupplier: '意向供应商账资料',
  intendedSupplierRegistered: '意向供应商账注册',
  bbcReturnAddress: '退货地址管理',
  returnDebitNote: '退货冲销单',
  ReturnDebitNoteDetail: '退货冲销单详情',
  matchingQualificationUpload: '合格证明文件匹配上传',
  certificateCollaboration: '证件协同',
};
